var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-alert',{attrs:{"value":_vm.error}}),_c('v-card',[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.result)+" ")])],1),_c('v-btn',{attrs:{"to":"/debug/trip"},on:{"click":_vm.create}},[_vm._v(" Create trip ")]),_c('TripDebugger')],1)}
var staticRenderFns = []

export { render, staticRenderFns }